export default {"src":"/_next/static/media/rascoda.fd1a8bc5.svg","height":29,"width":146,"blurWidth":0,"blurHeight":0};